import SI from "./enum.js";

const alert = (
	state = {
		alerts: [],
		authPopupOpen: false,
		authType: null,
	},
	action
) => {
	switch (action.type) {
		case SI.TOGGLE_AUTH_POPUP:
			return {
				...state,
				authPopupOpen: action.payload.isOpen,
				authType: action.payload.authType,
			};
		case SI.ALERT_IN:
			state.alerts.push(action.payload);
			return { ...state };
		case SI.ALERT_OUT:
			state.alerts.splice(action.payload, 1);
			return { ...state };
		default:
			return { ...state };
	}
};

export default alert;
